import { collection, onSnapshot } from "firebase/firestore";
import { database } from "../../utils/fipresConfig";
import Note from "../note/note"; // Corrected path
import { useState, useEffect, useRef } from "react";
import "./slider.css";

export default function Slider() {
  const [notes, setNotes] = useState([]);
  const sliderOddRef = useRef(null); // Ref for .slider_odd
  const sliderEvenRef = useRef(null); // Ref for .slider_even

  useEffect(() => {
    const notesRef = collection(database, "notes");
    const unsubscribe = onSnapshot(notesRef, (snapshot) => {
      const notesData = snapshot.docs.map((doc) => doc.data());
      setNotes(notesData);
    });
    return () => unsubscribe();
  }, []);

  const oddNotes = notes.filter((_, index) => index % 2 !== 0);
  const evenNotes = notes.filter((_, index) => index % 2 === 0);

  // Function to pause animation
  const pauseAnimation = () => {
    if (sliderOddRef.current && sliderEvenRef.current) {
      sliderOddRef.current.style.animationPlayState = "paused";
      sliderEvenRef.current.style.animationPlayState = "paused";
    }
  };

  // Function to resume animation
  const resumeAnimation = () => {
    if (sliderOddRef.current && sliderEvenRef.current) {
      sliderOddRef.current.style.animationPlayState = "running";
      sliderEvenRef.current.style.animationPlayState = "running";
    }
  };

  return (
    <div className="slider_continer">
      <h3 className="titels">All Notes</h3>
      <div className="slider" id="slider">
        <div className="slider_odd" ref={sliderOddRef}>
          {oddNotes.map((note, index) => (
            <Note
              key={index}
              text={note.text}
              name={note.name}
              onEdit={() => {}} // Placeholder for onEdit
              onDelete={() => {}} // Placeholder for onDelete
              isEditing={false} // Placeholder for isEditing
              editText={""} // Placeholder for editText
              setEditText={() => {}} // Placeholder for setEditText
              handleSave={() => {}} // Placeholder for handleSave
              canEdit={false} // Placeholder for canEdit
              onMouseEnter={pauseAnimation} // Pass pause function
              onMouseLeave={resumeAnimation} // Pass resume function
            />
          ))}
        </div>
        <div className="slider_even" ref={sliderEvenRef}>
          {evenNotes.map((note, index) => (
            <Note
              key={index}
              text={note.text}
              name={note.name}
              onEdit={() => {}} // Placeholder for onEdit
              onDelete={() => {}} // Placeholder for onDelete
              isEditing={false} // Placeholder for isEditing
              editText={""} // Placeholder for editText
              setEditText={() => {}} // Placeholder for setEditText
              handleSave={() => {}} // Placeholder for handleSave
              canEdit={false} // Placeholder for canEdit
              onMouseEnter={pauseAnimation} // Pass pause function
              onMouseLeave={resumeAnimation} // Pass resume function
            />
          ))}
        </div>
      </div>
    </div>
  );
}